import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2cfde2b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table-responsive" }
const _hoisted_2 = { class: "table table-borderless w-max-content" }
const _hoisted_3 = { class: "align-middle text-center" }

import { PropType } from 'vue'

import CellSort from '@/components/sort-field-table/index.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  columns: Array as PropType<Array<{ field: string; name: string; sort?: boolean; maxWidth?: boolean; defaultSort?: string }>>,
  data: Array as PropType<Array<{ field: any }>>,
  sortCells: Array,
  children: Element,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, ({ field, name, sort, maxWidth, defaultSort }, index) => {
            return (_openBlock(), _createElementBlock("th", {
              class: _normalizeClass([index === 0 ? 'border-top-radius' : '', index === __props.columns?.length - 1 ? 'border-left-radius' : '']),
              key: index
            }, [
              (__props.sortCells.includes(field))
                ? (_openBlock(), _createBlock(CellSort, {
                    key: 0,
                    title: name,
                    keyName: field,
                    active: sort,
                    maxWidth: maxWidth,
                    defaultSort: defaultSort
                  }, null, 8, ["title", "keyName", "active", "maxWidth", "defaultSort"]))
                : _createCommentVNode("", true),
              (!__props.sortCells?.includes(field))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(maxWidth ? 'wi-max-content' : '')
                  }, _toDisplayString(name), 3))
                : _createCommentVNode("", true)
            ], 2))
          }), 128))
        ])
      ]),
      _createElementVNode("tbody", null, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ]))
}
}

})